module.exports = __webpack_public_path__ + "img/mind_template_item_3_2.ad566b2e.png";